module.exports = "https://cdn.realtymogul.com/static/media/icon_buildings.4e988582.svg";